import { Component } from '@angular/core';

@Component({
    selector: 'lib-rdata-upgrade-ad',
    templateUrl: './rdata-upgrade-ad.component.html',
    styleUrls: ['./rdata-upgrade-ad.component.scss'],
    standalone: false
})
export class RdataUpgradeAdComponent{}
